import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notificationRow pointer", { new: !_ctx.item.readOn }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Ricevuta nuova prenotazione per l'escursione ",
        text: "Ricevuta nuova prenotazione per l'escursione "
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.item.villageTrip.name), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Utente ",
        text: "Utente "
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.item.customer.name), 1)
    ])
  ], 2))
}